import { useAuth, useToast } from "duck";
import { useUpdateOrganizationMutation } from "requests";
import { types } from "../../../duck";

export const useUpdateOrganization = (resolve: () => void) => {
  const [{ user }] = useAuth();
  const [updateOrganization] = useUpdateOrganizationMutation();
  const toast = useToast({
    status: "success",
    description: "Organization is updated successfully."
  });

  return (values: types.FormValues) =>
    updateOrganization({
      variables: {
        input: {
          name: values.name,
          description: values.description,
          contactEmail: values.contactEmail,
          _id: user.organization?._id || 0,
          logo:
            typeof values.logo === "number" ? { _id: values.logo } : values.logo
        }
      }
    }).then(() => {
      resolve();
      toast();
    });
};
